// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "4b01f9a45f0bd1a8e321" + ".chunk.js";
};